import type { FolderList } from '@/api/model/folderModel'
import type {
  RecipientOption,
  RecipientOptionList,
} from '@/api/send_cart/model/sendCartModel'

export enum SubPageEnum {
  RECIPIENT_MASTER_EDIT = 'recipientMasterEditPage',
  FILE_UPLOAD = 'fileUpload',
}

export enum ThirdPageEnum {
  RECIPIENT_MASTER_CREATE = 'recipientMasterCreate',
  RECIPIENT_MASTER_CHANGE_NAME = 'recipientMasterChangeName',
}

export interface State {
  activeSubPage: SubPageEnum | null
  activeThirdPage: ThirdPageEnum | null

  recipientMasterOptions: RecipientOptionList
  recipientMasterOptionsBackup: RecipientOptionList
  selectedRecipientMaster: RecipientOption | null

  folderList: FolderList

  submitFlag: string
  corporateNumberAddSubmitModal: boolean
  newCorporateNumber: string
  newCorporateName: string
  recipientDetailId: number
  selectedCorporateNumber: number
  selectedCorporateName: string

  isFirstClient: boolean
  newClientCode: string
  newClientName: string
  selectedClientCode: string
  selectedClientName: string

  newRecipientUserName: string
  newRecipientDepartmentName: string
  newRecipientMail: string
}

const state = (): State => ({
  activeSubPage: null,
  activeThirdPage: null,

  recipientMasterOptions: [],
  recipientMasterOptionsBackup: [],
  selectedRecipientMaster: null,

  folderList: [],

  submitFlag: '',
  corporateNumberAddSubmitModal: false,
  newCorporateNumber: '',
  newCorporateName: '',
  recipientDetailId: -1,
  selectedCorporateNumber: -1,
  selectedCorporateName: '',

  isFirstClient: false,
  newClientCode: '',
  newClientName: '',
  selectedClientCode: '',
  selectedClientName: '',

  newRecipientUserName: '',
  newRecipientDepartmentName: '',
  newRecipientMail: '',
})

export default state
